/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN BOOK API
 * Role: Admin
 * Scope: Books & Chapters Dropdown
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   ENDPOINTS
============================================================= */

const ADMIN_BOOK_ENDPOINT =
  "/admin/books/books.php";

const ADMIN_BOOK_CHAPTER_ENDPOINT =
  "/admin/books/bookChapter.php";

/* =============================================================
   GET BOOKS
============================================================= */

export const getAdminBooks = async (
  courseCategoryId,
  options = {}
) => {
  try {
    const res = await apiCall(
      "GET",
      `${ADMIN_BOOK_ENDPOINT}?course_category_id=${courseCategoryId}`,
      null,
      "Admin - Fetch Books",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message || "Failed to fetch books",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
    };
  } catch (error) {
    console.error("Admin Fetch Books Error:", error);

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
      data: [],
    };
  }
};

/* =============================================================
   GET BOOK CHAPTERS
============================================================= */

export const getAdminBookChapters = async (
  bookId,
  options = {}
) => {
  try {
    const res = await apiCall(
      "GET",
      `${ADMIN_BOOK_CHAPTER_ENDPOINT}?book_id=${bookId}`,
      null,
      "Admin - Fetch Book Chapters",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message ||
          "Failed to fetch book chapters",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
    };
  } catch (error) {
    console.error(
      "Admin Fetch Book Chapters Error:",
      error
    );

    return {
      success: false,
      message:
        error.message || "Unexpected error occurred",
      data: [],
    };
  }
};